import React from 'react';
import './Features.css';
import { ReactComponent as CuratedIcon } from '../icons/curated-icon.svg';
import { ReactComponent as VerifiedIcon } from '../icons/verified-icon.svg';
import { ReactComponent as TransparencyIcon } from '../icons/transparency-icon.svg';
import { ReactComponent as SaveTimeIcon } from '../icons/save-time-icon.svg';

const Features = () => {
  const features = [
    {
      icon: <CuratedIcon className='w-10 h-10'/>,
      title: "Curated for your needs",
      description: "Easily find venues matched to your event's type, size, and style with smart search and enhanced filters"
    },
    {
      icon: <VerifiedIcon className='w-10 h-10'/>,
      title: "100% verified and pre-vetted",
      description: "Every venue is thoroughly checked and approved by our team, so you can book with confidence."
    },
    {
      icon: <TransparencyIcon className='w-10 h-10'/>,
      title: "Complete transparency",
      description: "Clear pricing, detailed info, and no hidden fees — everything you need to make the right choice."
    },
    {
      icon: <SaveTimeIcon className='w-10 h-10'/>,
      title: "Save Time",
      description: "Find and book venues in minutes, not days of calling around and visiting the venues"
    }
  ];

    return (
        <div className="content-width mx-auto flex flex-col gap-12 md:gap-0 md:grid grid-cols-2 container-padding">
            <div className="col-span-2 font-playfair md:text-7xl text-5xl font-medium w-full">
              <p className='md:max-w-[65%] max-w-full'>Explore pre-vetted, local spaces</p>
            </div>
            <div className="col-start-2 flex flex-col gap-[48px]">
                {features.map((feature, index) => (
                    <div key={index} className="flex flex-row gap-4">
                        <div className="">
                            {feature.icon}
                        </div>
                        <div className="flex flex-col gap-2">
                            <div className="md:text-2xl text-xl font-medium">{feature.title}</div>
                              <div className="md:text-lg text-base font-normal text-gray-500">
                                {feature.description}
                              </div>
                        </div>
                    </div>
        ))}
      </div>
    </div>
  );
};

export default Features; 
